// Global function object
if (typeof madeBase === 'undefined') var madeBase  = {};
var newBooksSlider = '';

(function( $ ){

    madeBase.contentFeedSlider = $('.content-feed-slideshow').bxSlider();

    madeBase.getPostsNews = function() {
        if($('body.page-news').length){
            var getNews = new MadeGetPosts('post', '.news-results', null, true);
            getNews.run();

        }
    };

    madeBase.getPostsEvents = function() {
        if ($('body.page-events').length) {
            var getEvents = new MadeGetPosts('event', '.events-results', null, true);
            getEvents.run();

        }
    };

    madeBase.tabs = function() {
        $('.nav-tabs a').click(function (e) {
            e.preventDefault();
            $(this).tab('show');
        })
    };

    madeBase.contentBlockSlideshow = function() {
        $('.content-block-slideshow').bxSlider({
            mode: 'fade',
            captions: true
        });
    };

    madeBase.animateExpandCollapse = function () {
        $('.expand-collapse-trigger').click(function () {
            $(this).find('i').toggleClass('fa-rotate-180');
        });
    };

    madeBase.newBooksSliderInit = function () {
        newBooksSlider = $('#new-books .bxslider').bxSlider({
            'pagerSelector': $('.pager'),
            'auto': true,
            'pause': 5000,
            touchEnabled: false
        });
    };

    madeBase.matchHeightCTA = function () {
        $('.cta').matchHeight();

    };

    madeBase.matchHeightBottomBlocks = function () {
        $('#bottom-panel .cta').matchHeight();
    };

    madeBase.removePaddingForLastContentBlocksInSidebar = function () {
      $('.layout-sidebar .content-block').last().css('margin-bottom',0);
    };

    madeBase.matchHeightTestimonials = function () {
        $('.quote').matchHeight();
    };
    madeBase.toggleTextExpandable = function () {
        var triggerBlock = $('.literature-search-form .expand-block');
        var anchor = triggerBlock.find('a');
        var expandableBlock = $('.literature-search-form .collapse');
        expandableBlock.on('shown.bs.collapse',function () {
            anchor.find('span').text(anchor.data('text-collapse'));
        }).on('hidden.bs.collapse',function () {
            anchor.find('span').text(anchor.data('text-expand'));
        });

    };


    madeBase.datePicker = function () {
        $( "input[type='date']").datepicker({
                dateFormat: 'yy-mm-dd',
            }
        );
    };

    madeBase.customFormAlerts = function() {
        var wpcf7Elm = document.querySelector( '.wpcf7' ) !== null;

        if(wpcf7Elm) {
            wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
                alert( "Your registration form has been sent successfully." );
            }, false );

            wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
                alert( "There was an issue with one of the fields in the form. Please check and submit the form again." );
            }, false );


            wpcf7Elm.addEventListener( 'wpcf7mailfailed', function( event ) {
                alert( "There was a problem sending the form email." );
            }, false );
        }
    }



    $(document).ready(function() {
        madeBase.getPostsNews();
        madeBase.getPostsEvents();
        madeBase.tabs();
        madeBase.contentBlockSlideshow();
        madeBase.animateExpandCollapse();
        madeBase.matchHeightBottomBlocks();
        madeBase.removePaddingForLastContentBlocksInSidebar();
        madeBase.matchHeightTestimonials();
        madeBase.toggleTextExpandable();
        madeBase.datePicker();
        madeBase.customFormAlerts();

        $('iframe[src*="youtube"]').parent().fitVids();
        $('iframe[src*="vimeo"]').parent().fitVids();

        if($('body.page-home').length){
            madeBase.newBooksSliderInit();
            madeBase.matchHeightCTA();
        }
    });


})(jQuery);